module.exports = __webpack_public_path__ + "img/treppengelaender22.0a0e94ce.webp";